module.exports = __webpack_public_path__ + "img/info.2327ba83.svg";